/*
 * Sunday Moss product page helpers (PRODUCT owner). Loaded with `defer` from snippets/sm-pdp-band.liquid.
 * Depends on Dawn (pubsub.js / global.js, loaded in the head) and window.SMCommerce (sm-commerce.js).
 * Never edits Dawn JS: it listens to Dawn's own events and the main product form.
 *
 *   - Add to cart label keeps the price ("Add to cart · $40") after variant changes.
 *   - [data-sm-size-nudge]   500 mL -> 1 L / 250 mL -> 500 mL nudge, re-computed from variant prices.
 *   - [data-sm-mini-addon]   ticked mini is added right after the main form's successful add.
 *   - [data-sm-sticky-atc]   mobile sticky bar; submits the main form (one add path).
 *   - [data-sm-mix]          "Mix your own trio" builder; one SMCommerce.addItems call.
 *   - [data-sm-scroll-buy]   story CTA scrolls back to the buy box.
 */
(function () {
  'use strict';
  if (window.SMPdp) return; // quick-add modals re-inject this script
  window.SMPdp = true;

  function money(cents) {
    if (window.SMCommerce && typeof window.SMCommerce.money === 'function') return window.SMCommerce.money(cents);
    return '$' + (Number(cents || 0) / 100).toFixed(2);
  }
  function moneyShort(cents) {
    return money(cents).replace(/\.00(?!\d)/, '');
  }
  function sizeOf(o1) {
    var s = String(o1 || '').toLowerCase().replace(/\s+/g, '');
    if (s.indexOf('250') > -1) return 250;
    if (s.indexOf('500') > -1) return 500;
    if (s.indexOf('1l') > -1 || s.indexOf('1000') > -1) return 1000;
    return 0;
  }
  function formFor(section) { return document.getElementById('product-form-' + section); }
  function idInput(section) {
    var f = formFor(section);
    return f ? f.querySelector('input[name="id"]') : null;
  }
  function pickerFor(section) {
    return document.getElementById('variant-radios-' + section) || document.getElementById('variant-selects-' + section);
  }
  function variantsFromPicker(section) {
    /* Dawn 16's picker no longer embeds the variants JSON; main-product.liquid prints [data-sm-variants]. */
    var s = document.querySelector('script[data-sm-variants="' + section + '"]');
    var p = pickerFor(section);
    if (!s && !p) return [];
    s = s || p.querySelector('script[type="application/json"]:not([data-selected-variant])');
    try { return s ? JSON.parse(s.textContent) : []; } catch (e) { return []; }
  }
  /* Select a variant in Dawn's picker by its option values; fires ONE change so Dawn updates everything. */
  function selectOptions(section, values) {
    var picker = pickerFor(section);
    if (!picker || !values || !values.length) return false;
    var target = null;
    /* Dawn 16 renders button pickers as <variant-selects> with radio fieldsets (Dawn 11 used <variant-radios>). */
    var fieldsets = picker.querySelectorAll('fieldset');
    if (fieldsets.length && picker.querySelector('input[type="radio"]')) {
      values.forEach(function (val, i) {
        var fs = fieldsets[i];
        if (!fs) return;
        Array.prototype.forEach.call(fs.querySelectorAll('input[type="radio"]'), function (r) {
          if (r.value === val) { r.checked = true; target = target || r; }
        });
      });
    } else {
      var selects = picker.querySelectorAll('select');
      values.forEach(function (val, i) {
        if (selects[i]) { selects[i].value = val; target = target || selects[i]; }
      });
    }
    if (!target) return false;
    target.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  }
  function onIdChange(section, fn) {
    var input = idInput(section);
    if (input) input.addEventListener('change', function () { fn(Number(input.value)); });
  }
  function subscribeSafe(name, fn) {
    if (typeof window.subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS[name]) {
      return window.subscribe(PUB_SUB_EVENTS[name], fn);
    }
    return null;
  }

  /* ---------------- Add to cart label with price ---------------- */
  function initPhotoSync(band) {
    var section = band.getAttribute('data-section');
    subscribeSafe('variantChange', function (event) {
      var d = event && event.data;
      if (!d || d.sectionId !== section || !d.variant || !d.html) return;
      var product = band.closest('.product');
      var current = product && product.querySelector('[data-sm-pdp-art] [data-sm-photo-sync]');
      var next = d.html.querySelector('[data-sm-pdp-art] [data-sm-photo-sync]');
      if (current && next) current.replaceWith(next.cloneNode(true));
    });
  }

  function initAtcLabel(band) {
    var section = band.getAttribute('data-section');
    var label = band.getAttribute('data-add-label') || 'Add to cart';
    var product = band.closest('.product');
    var data = band.querySelector('[data-sm-price-data]');
    var variants = [];
    try { variants = data ? JSON.parse(data.textContent) : variantsFromPicker(section); } catch (e) { return; }
    var frame;
    function render() {
      frame = null;
      var form = formFor(section);
      var btn = form && form.querySelector('[name="add"]');
      var span = form && form.querySelector('[name="add"] > span');
      if (!btn || !span || btn.hasAttribute('disabled') || btn.getAttribute('aria-disabled') === 'true') return;
      var selected = new FormData(form);
      var variant = variants.filter(function (v) { return String(v.id) === String(selected.get('id')); })[0];
      if (!variant || !variant.available) return;
      var planId = String(selected.get('selling_plan') || '');
      var allocation = (variant.plans || []).filter(function (p) { return String(p.id) === planId; })[0];
      var amount = planId ? (allocation ? allocation.price : null) : variant.price;
      var amountText = amount === null ? '' : ' · ' + money(amount);
      if (span.textContent !== label + amountText) {
        span.textContent = label;
        if (amountText) {
          var price = document.createElement('span');
          price.className = 'sm-atc-price';
          price.textContent = amountText;
          span.appendChild(price);
        }
      }
      Array.prototype.forEach.call(document.querySelectorAll('[data-sm-sticky-atc]'), function (bar) {
        if (bar.getAttribute('data-section') !== section) return;
        var price = bar.querySelector('[data-sm-sticky-price]');
        var text = amount === null ? '' : money(amount);
        if (price && price.textContent !== text) price.textContent = text;
      });
    }
    function schedule() {
      if (!frame) frame = window.requestAnimationFrame(render);
    }
    if (product) {
      product.addEventListener('click', schedule);
      product.addEventListener('change', schedule);
      product.addEventListener('input', schedule);
      product.addEventListener('sm:plan-change', schedule);
      new MutationObserver(schedule).observe(product, {
        childList: true, subtree: true, attributes: true,
        attributeFilter: ['value', 'checked', 'disabled', 'aria-disabled']
      });
    }
    subscribeSafe('variantChange', function (event) {
      var d = event && event.data;
      if (d && d.sectionId === section) schedule();
    });
    schedule();
  }

  /* ---------------- Size nudge ---------------- */
  function initNudge(el) {
    var section = el.getAttribute('data-section');
    var data = [];
    var prices = [];
    var product = el.closest('.product');
    var priceData = product && product.querySelector('[data-sm-price-data]');
    try {
      data = JSON.parse(el.querySelector('[data-sm-size-data]').textContent);
      prices = priceData ? JSON.parse(priceData.textContent) : [];
    } catch (e) { return; }
    var text = el.querySelector('[data-sm-size-text]');
    var btn = el.querySelector('[data-sm-size-switch]');
    var pending = null;
    var frame;

    function find(size, rest) {
      return data.filter(function (v) { return v.size === size && v.rest === rest && v.available; })[0];
    }
    function amount(variant, planId) {
      if (!variant) return null;
      if (!planId) return variant.price;
      var priced = prices.filter(function (v) { return String(v.id) === String(variant.id); })[0];
      var allocation = priced && (priced.plans || []).filter(function (plan) { return String(plan.id) === planId; })[0];
      return allocation && typeof allocation.price === 'number' ? allocation.price : null;
    }
    function render() {
      frame = null;
      var form = formFor(section);
      var selected = form && new FormData(form);
      var id = selected && String(selected.get('id'));
      var planId = selected ? String(selected.get('selling_plan') || '') : '';
      var cur = data.filter(function (v) { return String(v.id) === id; })[0];
      var currentPrice = amount(cur, planId);
      var message = '';
      var buttonText = '';
      pending = null;
      if (cur && currentPrice !== null) {
        if (cur.size === 500) {
          var big = find(1000, cur.rest);
          var bigPrice = amount(big, planId);
          if (big && bigPrice !== null) {
            var extra = bigPrice - currentPrice;
            var less = currentPrice * 2 - bigPrice;
            message = 'Go 1 L for ' + (extra >= 0 ? '+' : '') + moneyShort(extra) + ': twice the gel' +
              (less > 0 ? ', ' + moneyShort(less) + ' less than two 500s.' : '.');
            pending = big; buttonText = 'Switch to 1 L';
          }
        } else if (cur.size === 1000) {
          message = 'Best value: ' + money(Math.round(currentPrice / 10)) + ' per 100 mL.';
        } else if (cur.size === 250) {
          message = 'Mini 250 mL. Perfect as an add-on.';
          var mid = find(500, cur.rest);
          if (mid && amount(mid, planId) !== null) { pending = mid; buttonText = 'Switch to 500 mL'; }
        }
      }
      el.setAttribute('data-size', message && cur ? cur.size : 0);
      if (text.textContent !== message) text.textContent = message;
      if (buttonText && btn.textContent !== buttonText) btn.textContent = buttonText;
      btn.hidden = !pending;
    }
    function schedule() {
      if (!frame) frame = window.requestAnimationFrame(render);
    }
    btn.addEventListener('click', function () {
      render();
      var target = pending;
      if (!target) return;
      var full = variantsFromPicker(section).filter(function (v) { return v.id === target.id; })[0];
      if (full) selectOptions(section, full.options);
      if (window.SMCommerce) window.SMCommerce.track('size_nudge_switch', { to: target.id });
    });
    if (product) {
      product.addEventListener('click', schedule);
      product.addEventListener('change', schedule);
      product.addEventListener('input', schedule);
      product.addEventListener('sm:plan-change', schedule);
      new MutationObserver(schedule).observe(product, {
        childList: true, subtree: true, attributes: true,
        attributeFilter: ['value', 'checked', 'disabled', 'aria-disabled']
      });
    }
    onIdChange(section, schedule);
    subscribeSafe('variantChange', function (event) {
      var d = event && event.data;
      if (d && d.sectionId === section) schedule();
    });
    render();
  }

  /* ---------------- Mini add-on ---------------- */
  function initMini(el) {
    var section = el.getAttribute('data-section');
    var check = el.querySelector('[data-sm-mini-check]');
    var select = el.querySelector('[data-sm-mini-select]');
    var miniTitle = (el.getAttribute('data-mini-title') || '250 ml').toLowerCase();
    if (!window.SMCommerce) { el.hidden = true; return; }

    function current() {
      if (select) return Number(select.value);
      var first = el.querySelector('[data-sm-mini-option]');
      return first ? Number(first.getAttribute('data-sm-mini-option')) : 0;
    }
    function showOption() {
      var id = String(current());
      Array.prototype.forEach.call(el.querySelectorAll('[data-sm-mini-option]'), function (o) {
        o.hidden = o.getAttribute('data-sm-mini-option') !== id;
      });
    }
    if (select) select.addEventListener('change', showOption);
    showOption();
    check.addEventListener('change', function () {
      el.classList.toggle('is-checked', check.checked);
    });

    var variants = variantsFromPicker(section);
    onIdChange(section, function (id) {
      var v = variants.filter(function (x) { return x.id === id; })[0];
      var isMini = v && String(v.title || '').trim().toLowerCase() === miniTitle;
      el.hidden = !!isMini;
      if (isMini && check.checked) { check.checked = false; el.classList.remove('is-checked'); }
    });

    subscribeSafe('cartUpdate', function (event) {
      if (!event || event.source !== 'product-form' || !check.checked || el.hidden) return;
      var input = idInput(section);
      if (!input || String(event.productVariantId) !== String(input.value)) return;
      var id = current();
      if (!id) return;
      check.checked = false;
      el.classList.remove('is-checked');
      window.SMCommerce.addItems([{ id: id, quantity: 1 }], { source: 'pdp-mini', open: false })
        .catch(function (err) {
          var slot = el.querySelector('[data-sm-error]');
          if (slot) slot.textContent = (err && err.message) || 'We could not add the mini. Please try again.';
        });
    });
  }

  /* ---------------- Sticky add bar (mobile) ---------------- */
  function initSticky(bar) {
    var section = bar.getAttribute('data-section');
    var form = formFor(section);
    if (!form) { bar.remove(); return; }
    var mainBtn = form.querySelector('[name="add"]');
    var select = bar.querySelector('[data-sm-sticky-select]');
    var add = bar.querySelector('[data-sm-sticky-add]');
    var price = bar.querySelector('[data-sm-sticky-price]');
    var variants = variantsFromPicker(section);
    var mq = window.matchMedia('(max-width: 749px)');

    // Keep the bar out of the page flow at the end of <body> so no section clips it.
    document.body.appendChild(bar);

    function setVisible(on) {
      on = on && mq.matches;
      bar.classList.toggle('is-visible', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      Array.prototype.forEach.call(bar.querySelectorAll('select, button'), function (c) { c.tabIndex = on ? 0 : -1; });
      document.body.classList.toggle('sm-sticky-on', on);
    }
    function sync(id) {
      var v = variants.filter(function (x) { return x.id === id; })[0];
      if (select && v) select.value = String(id);
      if (v) price.textContent = money(v.price);
      add.disabled = v ? !v.available : !!(mainBtn && mainBtn.hasAttribute('disabled'));
    }
    if ('IntersectionObserver' in window && mainBtn) {
      var io = new IntersectionObserver(function (entries) {
        var e = entries[0];
        setVisible(!e.isIntersecting && e.boundingClientRect.top < 0);
      });
      io.observe(mainBtn);
    }
    if (mq.addEventListener) mq.addEventListener('change', function () { if (!mq.matches) setVisible(false); });
    onIdChange(section, sync);

    if (select) {
      select.addEventListener('change', function () {
        var opt = select.options[select.selectedIndex];
        var values = (opt.getAttribute('data-options') || '').split('||');
        selectOptions(section, values);
      });
    }
    add.addEventListener('click', function () {
      if (add.disabled) return;
      if (mainBtn && mainBtn.getAttribute('aria-disabled') === 'true') return;
      add.classList.add('is-loading');
      add.setAttribute('aria-busy', 'true');
      if (typeof form.requestSubmit === 'function') form.requestSubmit();
      else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
      setTimeout(function () { add.classList.remove('is-loading'); add.removeAttribute('aria-busy'); }, 1200);
    });
  }

  /* ---------------- Mix your own trio ---------------- */
  function initMix(el) {
    var items = Array.prototype.slice.call(el.querySelectorAll('[data-sm-mix-item]'));
    var total = el.querySelector('[data-sm-mix-total]');
    var submit = el.querySelector('[data-sm-mix-submit]');
    var discountOn = el.getAttribute('data-mix-enabled') === 'true';
    var p2 = Number(el.getAttribute('data-p2') || 0);
    var p3 = Number(el.getAttribute('data-p3') || 0);
    var idle = total.textContent;

    function qtyOf(item) { return Number(item.querySelector('[data-sm-mix-qty]').textContent) || 0; }
    function priceOf(item) {
      var s = item.querySelector('[data-sm-mix-size]');
      var o = s.options[s.selectedIndex];
      return Number(o.getAttribute('data-price')) || 0;
    }
    function render() {
      var count = 0, sum = 0;
      items.forEach(function (it) {
        var q = qtyOf(it);
        count += q; sum += q * priceOf(it);
        it.classList.toggle('is-selected', q > 0);
        it.querySelector('[data-sm-mix-minus]').disabled = q === 0;
      });
      submit.disabled = count === 0;
      if (!count) { total.textContent = idle; submit.textContent = 'Add to cart'; return; }
      var line = count + (count === 1 ? ' jar' : ' jars') + ' · ' + money(sum);
      if (discountOn) {
        var pct = count >= 3 ? p3 : count === 2 ? p2 : 0;
        if (pct) line += ' (save ' + pct + '% at checkout)';
      }
      if (count < 3) line += ' · pick ' + (3 - count) + ' more for a trio';
      total.textContent = line;
      submit.textContent = 'Add ' + count + (count === 1 ? ' jar' : ' jars') + ' · ' + money(sum);
    }
    el.addEventListener('click', function (e) {
      var b = e.target.closest('[data-sm-mix-plus], [data-sm-mix-minus]');
      if (!b) return;
      var it = b.closest('[data-sm-mix-item]');
      var q = it.querySelector('[data-sm-mix-qty]');
      var n = qtyOf(it) + (b.hasAttribute('data-sm-mix-plus') ? 1 : -1);
      q.textContent = String(Math.max(0, Math.min(12, n)));
      render();
    });
    el.addEventListener('change', function (e) { if (e.target.matches('[data-sm-mix-size]')) render(); });
    submit.addEventListener('click', function () {
      if (!window.SMCommerce) return;
      var list = [];
      items.forEach(function (it) {
        var q = qtyOf(it);
        if (q > 0) list.push({ id: Number(it.querySelector('[data-sm-mix-size]').value), quantity: q });
      });
      if (!list.length) return;
      var slot = el.querySelector('[data-sm-error]');
      if (slot) slot.textContent = '';
      submit.classList.add('is-loading'); submit.disabled = true; submit.setAttribute('aria-busy', 'true');
      window.SMCommerce.addItems(list, { source: 'pdp-mix', open: true }).then(function () {
        items.forEach(function (it) { it.querySelector('[data-sm-mix-qty]').textContent = '0'; });
      }).catch(function (err) {
        if (slot) slot.textContent = (err && err.message) || 'Something went wrong. Please try again.';
      }).then(function () {
        submit.classList.remove('is-loading'); submit.removeAttribute('aria-busy');
        render();
      });
    });
    render();
  }

  /* ---------------- Story CTA ---------------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-sm-scroll-buy]');
    if (!a) return;
    var band = document.querySelector('[data-sm-pdp-band]');
    var form = band && formFor(band.getAttribute('data-section'));
    var picker = band && pickerFor(band.getAttribute('data-section'));
    var target = picker || form;
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });

  function init(root) {
    root = root || document;
    Array.prototype.forEach.call(root.querySelectorAll('[data-sm-pdp-band]:not([data-ready])'), function (el) {
      if (el.closest('quick-add-modal')) return;
      el.setAttribute('data-ready', ''); initAtcLabel(el); initPhotoSync(el);
    });
    [['[data-sm-size-nudge]', initNudge], ['[data-sm-mini-addon]', initMini], ['[data-sm-sticky-atc]', initSticky], ['[data-sm-mix]', initMix]]
      .forEach(function (pair) {
        Array.prototype.forEach.call(root.querySelectorAll(pair[0] + ':not([data-ready])'), function (el) {
          if (el.closest('quick-add-modal')) return;
          el.setAttribute('data-ready', '');
          try { pair[1](el); } catch (err) { if (window.console) console.error('[sm-pdp]', err); }
        });
      });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
